<!-- tab切换 -->
<template>
    <el-tabs v-model="active" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in list" :label="item[props.label]" :name="item[props.name]" :key="index">
            <div slot="label" class="label" :class="item[props.name] == active ? 'background' : ''">
                <p>{{ item[props.label] }}</p>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
export default {
    name: "matrix-tabs",
    props: {
        list: {
            type: Array,
            default: () => { return [] }
        },
        activeName: {
            type: String,
            default: ''
        },
        props: {
            type: Object,
            default: () => {
                return {
                    label: 'label',
                    name: 'name'
                }
            }
        }
    },
    data() {
        return {
            active: ''
        };
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$func.isEmpty(this.activeName) && this.list.length > 0) {
                this.active = this.list[0][this.props.name]
            } else {
                this.active = this.activeName
            }
        })
    },
    methods: {
        handleClick(tab) {
            this.$emit('handleClick', tab)
        }
    }
};
</script>

<style scoped lang="scss">
.label {
    width: 105px;
    height: 45px;
    border-radius: 4px;
    text-align: center;

    p {
        margin: 0;
        color: #4B5563;
    }
}

.background {
    background: $mainBg;

    p {
        color: #fff;
    }

}

::v-deep .el-tabs__item {
    padding: 0 !important;
}

::v-deep .el-tabs__active-bar {
    display: none !important;
}
</style>